import Signup from "../components/Signup";
import Navbar from "../components/Navbar";

export default function Register(){
  return(
    <div className="register-page">
      <Navbar />
      <Signup />
    </div>
  )
}